import { isCustom, isStepRequired } from '@authFlow/utils/signupHelpers';
import { Custom } from '@authFlow/utils/authFlowFlags';
import { storageManager } from '@authFlow/utils/SessionStorageManager';

export const getPersonalisedPlan = async (): Promise<string> => {
  if (isCustom(Custom.aiSeo)) {
    return Custom.aiSeo;
  }

  const toolkit = storageManager.get('toolkit');
  const custom = storageManager.get('custom');

  if (
    (!isStepRequired('survey') && isStepRequired('toolkitSelection')) ||
    (custom && ![Custom.copilot, Custom.seoToolkit].includes(custom)) ||
    toolkit === 'seo'
  ) {
    return null;
  }

  if (
    isCustom(Custom.copilot) ||
    toolkit === 'all' ||
    isStepRequired('trial') ||
    (window.sm2?.user?.id &&
      window.location.pathname === '/signup/get-free-trial/')
  ) {
    return Custom.semrushOne;
  }

  return null;
};
